export default {
  "leagueoflegends": [
    {
      fieldName: "selectInput",
      label: "Select your Rank:",
      options: [
        {
          label: "Iron",
          value: "iron",
          image: require("@/assets/images/games/leagueoflegends/ranks/iron.png"),
        },
        {
          label: "Bronze",
          value: "bronze",
          image: require("@/assets/images/games/leagueoflegends/ranks/bronze.png"),
        },
        {
          label: "Silver",
          value: "silver",
          image: require("@/assets/images/games/leagueoflegends/ranks/silver.png"),
        },
        {
          label: "Gold",
          value: "gold",
          image: require("@/assets/images/games/leagueoflegends/ranks/gold.png"),
        },
        {
          label: "Platinum",
          value: "platinum",
          image: require("@/assets/images/games/leagueoflegends/ranks/platinum.png"),
        },
        {
          label: "Diamond",
          value: "diamond",
          image: require("@/assets/images/games/leagueoflegends/ranks/diamond.png"),
        },
      ],
    },
    {
      fieldName: "secondarySelectInput",
      label: "Select your Division:",
      options: [
        {
          label: "I",
          value: "i",
          image: require("@/assets/images/games/leagueoflegends/divisions/I.svg"),
        },
        {
          label: "II",
          value: "ii",
          image: require("@/assets/images/games/leagueoflegends/divisions/II.svg"),
        },
        {
          label: "III",
          value: "iii",
          image: require("@/assets/images/games/leagueoflegends/divisions/III.svg"),
        },
        {
          label: "IV",
          value: "iv",
          image: require("@/assets/images/games/leagueoflegends/divisions/IV.svg"),
        },
      ],
    },
  ],
  "fortnite": [
    {
      fieldName: "selectInput",
      label: "Select your average K/D:",
      options: [
        // {
        //   label: 'Under .25',
        //   value: '< 0.25',
        //   image: require('@/assets/images/games/fortnite/kd/_0.25.svg'),
        //   imageLabel: 'K/D'
        // },
        {
          label: "0.25 KD",
          value: "0.25",
          image: require("@/assets/images/games/fortnite/kd/0.25.svg"),
          imageLabel: "K/D",
        },
        {
          label: "0.5 KD",
          value: "0.50",
          image: require("@/assets/images/games/fortnite/kd/0.5.svg"),
          imageLabel: "K/D",
        },
        {
          label: "0.75 KD",
          value: "0.75",
          image: require("@/assets/images/games/fortnite/kd/0.75.svg"),
          imageLabel: "K/D",
        },
        {
          label: "1 KD",
          value: "1.00",
          image: require("@/assets/images/games/fortnite/kd/1.svg"),
          imageLabel: "K/D",
        },
        {
          label: "2 KD",
          value: "2.00",
          image: require("@/assets/images/games/fortnite/kd/2.svg"),
          imageLabel: "K/D",
        },
        {
          label: "3 KD",
          value: "3.00",
          image: require("@/assets/images/games/fortnite/kd/3.svg"),
          imageLabel: "K/D",
        },
        {
          label: "4 KD",
          value: "4.00",
          image: require("@/assets/images/games/fortnite/kd/4.svg"),
          imageLabel: "K/D",
        },
      ],
    },
  ],
  "hearthstone": [
    {
      fieldName: "selectInput",
      label: "Select your Rank:",
      options: [
        {
          label: "Rank 25",
          value: "25",
          image: require("@/assets/images/games/hearthstone/ranks/25.png"),
        },
        {
          label: "Rank 24",
          value: "24",
          image: require("@/assets/images/games/hearthstone/ranks/24.png"),
        },
        {
          label: "Rank 23",
          value: "23",
          image: require("@/assets/images/games/hearthstone/ranks/23.png"),
        },
        {
          label: "Rank 22",
          value: "22",
          image: require("@/assets/images/games/hearthstone/ranks/22.png"),
        },
        {
          label: "Rank 21",
          value: "21",
          image: require("@/assets/images/games/hearthstone/ranks/21.png"),
        },
        {
          label: "Rank 20",
          value: "20",
          image: require("@/assets/images/games/hearthstone/ranks/20.png"),
        },
        {
          label: "Rank 19",
          value: "19",
          image: require("@/assets/images/games/hearthstone/ranks/19.png"),
        },
        {
          label: "Rank 18",
          value: "18",
          image: require("@/assets/images/games/hearthstone/ranks/18.png"),
        },
        {
          label: "Rank 17",
          value: "17",
          image: require("@/assets/images/games/hearthstone/ranks/17.png"),
        },
        {
          label: "Rank 16",
          value: "16",
          image: require("@/assets/images/games/hearthstone/ranks/16.png"),
        },
        {
          label: "Rank 15",
          value: "15",
          image: require("@/assets/images/games/hearthstone/ranks/15.png"),
        },
        {
          label: "Rank 14",
          value: "14",
          image: require("@/assets/images/games/hearthstone/ranks/14.png"),
        },
        {
          label: "Rank 13",
          value: "13",
          image: require("@/assets/images/games/hearthstone/ranks/13.png"),
        },
        {
          label: "Rank 12",
          value: "12",
          image: require("@/assets/images/games/hearthstone/ranks/12.png"),
        },
        {
          label: "Rank 11",
          value: "11",
          image: require("@/assets/images/games/hearthstone/ranks/11.png"),
        },
        {
          label: "Rank 10",
          value: "10",
          image: require("@/assets/images/games/hearthstone/ranks/10.png"),
        },
        {
          label: "Rank 9",
          value: "9",
          image: require("@/assets/images/games/hearthstone/ranks/9.png"),
        },
        {
          label: "Rank 8",
          value: "8",
          image: require("@/assets/images/games/hearthstone/ranks/8.png"),
        },
        {
          label: "Rank 7",
          value: "7",
          image: require("@/assets/images/games/hearthstone/ranks/7.png"),
        },
        {
          label: "Rank 6",
          value: "6",
          image: require("@/assets/images/games/hearthstone/ranks/6.png"),
        },
        {
          label: "Rank 5",
          value: "5",
          image: require("@/assets/images/games/hearthstone/ranks/5.png"),
        },
        {
          label: "Rank 4",
          value: "4",
          image: require("@/assets/images/games/hearthstone/ranks/4.png"),
        },
        {
          label: "Rank 3",
          value: "3",
          image: require("@/assets/images/games/hearthstone/ranks/3.png"),
        },
        {
          label: "Rank 2",
          value: "2",
          image: require("@/assets/images/games/hearthstone/ranks/2.png"),
        },
        {
          label: "Rank 1",
          value: "1",
          image: require("@/assets/images/games/hearthstone/ranks/1.png"),
        },
        {
          label: "Legend",
          value: "legend",
          image: require("@/assets/images/games/hearthstone/ranks/legend.png"),
        },
      ],
    },
  ],
  "csgo": [
    {
      fieldName: "selectInput",
      label: "Select your Rank:",
      options: [
        {
          label: "Silver I",
          value: "Silver I",
          image: require("@/assets/images/games/csgo/ranks/Silver I.png"),
        },
        {
          label: "Silver II",
          value: "Silver II",
          image: require("@/assets/images/games/csgo/ranks/Silver II.png"),
        },
        {
          label: "Silver III",
          value: "Silver III",
          image: require("@/assets/images/games/csgo/ranks/Silver III.png"),
        },
        {
          label: "Silver IV",
          value: "Silver IV",
          image: require("@/assets/images/games/csgo/ranks/Silver IV.png"),
        },
        {
          label: "Silver Elite",
          value: "Silver Elite",
          image: require("@/assets/images/games/csgo/ranks/Silver Elite.png"),
        },
        {
          label: "Silver Elite Master",
          value: "Silver Elite Master",
          image: require("@/assets/images/games/csgo/ranks/Silver Elite Master.png"),
        },
        {
          label: "Gold Nova I",
          value: "Gold Nova I",
          image: require("@/assets/images/games/csgo/ranks/Gold Nova I.png"),
        },
        {
          label: "Gold Nova II",
          value: "Gold Nova II",
          image: require("@/assets/images/games/csgo/ranks/Gold Nova II.png"),
        },
        {
          label: "Gold Nova III",
          value: "Gold Nova III",
          image: require("@/assets/images/games/csgo/ranks/Gold Nova III.png"),
        },
        {
          label: "Gold Nova Master",
          value: "Gold Nova Master",
          image: require("@/assets/images/games/csgo/ranks/Gold Nova Master.png"),
        },
        {
          label: "Master Guardian I",
          value: "Master Guardian I",
          image: require("@/assets/images/games/csgo/ranks/Master Guardian I.png"),
        },
        {
          label: "Master Guardian II",
          value: "Master Guardian II",
          image: require("@/assets/images/games/csgo/ranks/Master Guardian II.png"),
        },
        {
          label: "Master Guardian Elite",
          value: "Master Guardian Elite",
          image: require("@/assets/images/games/csgo/ranks/Master Guardian Elite.png"),
        },
        {
          label: "Distinguished Master Guardian",
          value: "Distinguished Master Guardian",
          image: require("@/assets/images/games/csgo/ranks/Distinguished Master Guardian.png"),
        },
        {
          label: "Legendary Eagle",
          value: "Legendary Eagle",
          image: require("@/assets/images/games/csgo/ranks/Legendary Eagle.png"),
        },
        {
          label: "Legendary Eagle Master",
          value: "Legendary Eagle Master",
          image: require("@/assets/images/games/csgo/ranks/Legendary Eagle Master.png"),
        },
        {
          label: "Supreme Master First Class",
          value: "Supreme Master First Class",
          image: require("@/assets/images/games/csgo/ranks/Supreme Master First Class.png"),
        },
      ],
    },
  ],
}



// WEBPACK FOOTER //
// ./src/store/data/marketing/games-rank-predictor.js